import styled from "styled-components";

export const DivLiveTag = styled.span`
  position: absolute;
  left: 20px;
  top: 20px;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 2px;
  background: linear-gradient(to left, #f4ff00, #71d200);
  z-index: 1;
`;
